const formatDate = (date, options = { dataStyle: 'short'}) => {
    const english = document.documentElement.lang.startsWith('en')
    return english
        ? date.toLocaleDateString('en-US', options)
        : date.toLocaleDateString('de-DE', options)

}

const formatTime = (date, options = { timeStyle: 'short' }) => {
    const english = document.documentElement.lang.startsWith('en')
    return english
        ? date.toLocaleTimeString('en-US', options)
        : date.toLocaleTimeString('de-DE', options)
}

export { formatDate, formatTime }
